'use strict';

function getOffsets(breakpoints) {
  var className = {};
  for (var size in breakpoints) {
    if (breakpoints.hasOwnProperty(size)) {
      className['col-' + size + '-offset-' + (12 - breakpoints[size])] = true;
    }
  }
  return className;
}

module.exports = getOffsets;


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/uvdom-bootstrap/lib/getOffsets.js
 ** module id = 143
 ** module chunks = 0
 **/